import { jsx as ke, Fragment as ot } from "react/jsx-runtime";
import Xe from "./Code.js";
import { b as lt, c as An, _ as it, a as st } from "./chunks/toConsumableArray-D44adFtk.js";
import Q from "react";
import { c as be, g as ee } from "./chunks/_commonjsHelpers-DaMA6jEr.js";
const ct = {
  'code[class*="language-"]': {
    color: "black",
    background: "none",
    fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    fontSize: "1em",
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    wordWrap: "normal",
    lineHeight: "1.5",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none",
    maxHeight: "inherit",
    height: "inherit",
    padding: "0 1em",
    display: "block",
    overflow: "auto"
  },
  'pre[class*="language-"]': {
    color: "black",
    background: "none",
    fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    fontSize: "1em",
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    wordWrap: "normal",
    lineHeight: "1.5",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none",
    position: "relative",
    margin: ".5em 0",
    overflow: "visible",
    padding: "1px",
    backgroundColor: "#fdfdfd",
    WebkitBoxSizing: "border-box",
    MozBoxSizing: "border-box",
    boxSizing: "border-box",
    marginBottom: "1em"
  },
  'pre[class*="language-"] > code': {
    position: "relative",
    zIndex: "1",
    borderLeft: "10px solid #358ccb",
    boxShadow: "-1px 0px 0px 0px #358ccb, 0px 0px 0px 1px #dfdfdf",
    backgroundColor: "#fdfdfd",
    backgroundImage: "linear-gradient(transparent 50%, rgba(69, 142, 209, 0.04) 50%)",
    backgroundSize: "3em 3em",
    backgroundOrigin: "content-box",
    backgroundAttachment: "local"
  },
  ':not(pre) > code[class*="language-"]': {
    backgroundColor: "#fdfdfd",
    WebkitBoxSizing: "border-box",
    MozBoxSizing: "border-box",
    boxSizing: "border-box",
    marginBottom: "1em",
    position: "relative",
    padding: ".2em",
    borderRadius: "0.3em",
    color: "#c92c2c",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    display: "inline",
    whiteSpace: "normal"
  },
  'pre[class*="language-"]:before': {
    content: "''",
    display: "block",
    position: "absolute",
    bottom: "0.75em",
    left: "0.18em",
    width: "40%",
    height: "20%",
    maxHeight: "13em",
    boxShadow: "0px 13px 8px #979797",
    WebkitTransform: "rotate(-2deg)",
    MozTransform: "rotate(-2deg)",
    msTransform: "rotate(-2deg)",
    OTransform: "rotate(-2deg)",
    transform: "rotate(-2deg)"
  },
  'pre[class*="language-"]:after': {
    content: "''",
    display: "block",
    position: "absolute",
    bottom: "0.75em",
    left: "auto",
    width: "40%",
    height: "20%",
    maxHeight: "13em",
    boxShadow: "0px 13px 8px #979797",
    WebkitTransform: "rotate(2deg)",
    MozTransform: "rotate(2deg)",
    msTransform: "rotate(2deg)",
    OTransform: "rotate(2deg)",
    transform: "rotate(2deg)",
    right: "0.75em"
  },
  comment: {
    color: "#7D8B99"
  },
  "block-comment": {
    color: "#7D8B99"
  },
  prolog: {
    color: "#7D8B99"
  },
  doctype: {
    color: "#7D8B99"
  },
  cdata: {
    color: "#7D8B99"
  },
  punctuation: {
    color: "#5F6364"
  },
  property: {
    color: "#c92c2c"
  },
  tag: {
    color: "#c92c2c"
  },
  boolean: {
    color: "#c92c2c"
  },
  number: {
    color: "#c92c2c"
  },
  "function-name": {
    color: "#c92c2c"
  },
  constant: {
    color: "#c92c2c"
  },
  symbol: {
    color: "#c92c2c"
  },
  deleted: {
    color: "#c92c2c"
  },
  selector: {
    color: "#2f9c0a"
  },
  "attr-name": {
    color: "#2f9c0a"
  },
  string: {
    color: "#2f9c0a"
  },
  char: {
    color: "#2f9c0a"
  },
  function: {
    color: "#2f9c0a"
  },
  builtin: {
    color: "#2f9c0a"
  },
  inserted: {
    color: "#2f9c0a"
  },
  operator: {
    color: "#a67f59",
    background: "rgba(255, 255, 255, 0.5)"
  },
  entity: {
    color: "#a67f59",
    background: "rgba(255, 255, 255, 0.5)",
    cursor: "help"
  },
  url: {
    color: "#a67f59",
    background: "rgba(255, 255, 255, 0.5)"
  },
  variable: {
    color: "#a67f59",
    background: "rgba(255, 255, 255, 0.5)"
  },
  atrule: {
    color: "#1990b8"
  },
  "attr-value": {
    color: "#1990b8"
  },
  keyword: {
    color: "#1990b8"
  },
  "class-name": {
    color: "#1990b8"
  },
  regex: {
    color: "#e90"
  },
  important: {
    color: "#e90",
    fontWeight: "normal"
  },
  ".language-css .token.string": {
    color: "#a67f59",
    background: "rgba(255, 255, 255, 0.5)"
  },
  ".style .token.string": {
    color: "#a67f59",
    background: "rgba(255, 255, 255, 0.5)"
  },
  bold: {
    fontWeight: "bold"
  },
  italic: {
    fontStyle: "italic"
  },
  namespace: {
    Opacity: ".7"
  },
  'pre[class*="language-"].line-numbers.line-numbers': {
    paddingLeft: "0"
  },
  'pre[class*="language-"].line-numbers.line-numbers code': {
    paddingLeft: "3.8em"
  },
  'pre[class*="language-"].line-numbers.line-numbers .line-numbers-rows': {
    left: "0"
  },
  'pre[class*="language-"][data-line]': {
    paddingTop: "0",
    paddingBottom: "0",
    paddingLeft: "0"
  },
  "pre[data-line] code": {
    position: "relative",
    paddingLeft: "4em"
  },
  "pre .line-highlight": {
    marginTop: "0"
  }
};
function Pe(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    n && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function ie(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Pe(Object(t), !0).forEach(function(a) {
      An(e, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Pe(Object(t)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return e;
}
function ut(e) {
  var n = e.length;
  if (n === 0 || n === 1) return e;
  if (n === 2)
    return [e[0], e[1], "".concat(e[0], ".").concat(e[1]), "".concat(e[1], ".").concat(e[0])];
  if (n === 3)
    return [e[0], e[1], e[2], "".concat(e[0], ".").concat(e[1]), "".concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[0]), "".concat(e[1], ".").concat(e[2]), "".concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[1]), "".concat(e[0], ".").concat(e[1], ".").concat(e[2]), "".concat(e[0], ".").concat(e[2], ".").concat(e[1]), "".concat(e[1], ".").concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[0], ".").concat(e[1]), "".concat(e[2], ".").concat(e[1], ".").concat(e[0])];
  if (n >= 4)
    return [e[0], e[1], e[2], e[3], "".concat(e[0], ".").concat(e[1]), "".concat(e[0], ".").concat(e[2]), "".concat(e[0], ".").concat(e[3]), "".concat(e[1], ".").concat(e[0]), "".concat(e[1], ".").concat(e[2]), "".concat(e[1], ".").concat(e[3]), "".concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[1]), "".concat(e[2], ".").concat(e[3]), "".concat(e[3], ".").concat(e[0]), "".concat(e[3], ".").concat(e[1]), "".concat(e[3], ".").concat(e[2]), "".concat(e[0], ".").concat(e[1], ".").concat(e[2]), "".concat(e[0], ".").concat(e[1], ".").concat(e[3]), "".concat(e[0], ".").concat(e[2], ".").concat(e[1]), "".concat(e[0], ".").concat(e[2], ".").concat(e[3]), "".concat(e[0], ".").concat(e[3], ".").concat(e[1]), "".concat(e[0], ".").concat(e[3], ".").concat(e[2]), "".concat(e[1], ".").concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[0], ".").concat(e[3]), "".concat(e[1], ".").concat(e[2], ".").concat(e[0]), "".concat(e[1], ".").concat(e[2], ".").concat(e[3]), "".concat(e[1], ".").concat(e[3], ".").concat(e[0]), "".concat(e[1], ".").concat(e[3], ".").concat(e[2]), "".concat(e[2], ".").concat(e[0], ".").concat(e[1]), "".concat(e[2], ".").concat(e[0], ".").concat(e[3]), "".concat(e[2], ".").concat(e[1], ".").concat(e[0]), "".concat(e[2], ".").concat(e[1], ".").concat(e[3]), "".concat(e[2], ".").concat(e[3], ".").concat(e[0]), "".concat(e[2], ".").concat(e[3], ".").concat(e[1]), "".concat(e[3], ".").concat(e[0], ".").concat(e[1]), "".concat(e[3], ".").concat(e[0], ".").concat(e[2]), "".concat(e[3], ".").concat(e[1], ".").concat(e[0]), "".concat(e[3], ".").concat(e[1], ".").concat(e[2]), "".concat(e[3], ".").concat(e[2], ".").concat(e[0]), "".concat(e[3], ".").concat(e[2], ".").concat(e[1]), "".concat(e[0], ".").concat(e[1], ".").concat(e[2], ".").concat(e[3]), "".concat(e[0], ".").concat(e[1], ".").concat(e[3], ".").concat(e[2]), "".concat(e[0], ".").concat(e[2], ".").concat(e[1], ".").concat(e[3]), "".concat(e[0], ".").concat(e[2], ".").concat(e[3], ".").concat(e[1]), "".concat(e[0], ".").concat(e[3], ".").concat(e[1], ".").concat(e[2]), "".concat(e[0], ".").concat(e[3], ".").concat(e[2], ".").concat(e[1]), "".concat(e[1], ".").concat(e[0], ".").concat(e[2], ".").concat(e[3]), "".concat(e[1], ".").concat(e[0], ".").concat(e[3], ".").concat(e[2]), "".concat(e[1], ".").concat(e[2], ".").concat(e[0], ".").concat(e[3]), "".concat(e[1], ".").concat(e[2], ".").concat(e[3], ".").concat(e[0]), "".concat(e[1], ".").concat(e[3], ".").concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[3], ".").concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[0], ".").concat(e[1], ".").concat(e[3]), "".concat(e[2], ".").concat(e[0], ".").concat(e[3], ".").concat(e[1]), "".concat(e[2], ".").concat(e[1], ".").concat(e[0], ".").concat(e[3]), "".concat(e[2], ".").concat(e[1], ".").concat(e[3], ".").concat(e[0]), "".concat(e[2], ".").concat(e[3], ".").concat(e[0], ".").concat(e[1]), "".concat(e[2], ".").concat(e[3], ".").concat(e[1], ".").concat(e[0]), "".concat(e[3], ".").concat(e[0], ".").concat(e[1], ".").concat(e[2]), "".concat(e[3], ".").concat(e[0], ".").concat(e[2], ".").concat(e[1]), "".concat(e[3], ".").concat(e[1], ".").concat(e[0], ".").concat(e[2]), "".concat(e[3], ".").concat(e[1], ".").concat(e[2], ".").concat(e[0]), "".concat(e[3], ".").concat(e[2], ".").concat(e[0], ".").concat(e[1]), "".concat(e[3], ".").concat(e[2], ".").concat(e[1], ".").concat(e[0])];
}
var $e = {};
function gt(e) {
  if (e.length === 0 || e.length === 1) return e;
  var n = e.join(".");
  return $e[n] || ($e[n] = ut(e)), $e[n];
}
function dt(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = arguments.length > 2 ? arguments[2] : void 0, a = e.filter(function(u) {
    return u !== "token";
  }), o = gt(a);
  return o.reduce(function(u, d) {
    return ie(ie({}, u), t[d]);
  }, n);
}
function Qe(e) {
  return e.join(" ");
}
function pt(e, n) {
  var t = 0;
  return function(a) {
    return t += 1, a.map(function(o, u) {
      return Fn({
        node: o,
        stylesheet: e,
        useInlineStyles: n,
        key: "code-segment-".concat(t, "-").concat(u)
      });
    });
  };
}
function Fn(e) {
  var n = e.node, t = e.stylesheet, a = e.style, o = a === void 0 ? {} : a, u = e.useInlineStyles, d = e.key, i = n.properties, v = n.type, k = n.tagName, m = n.value;
  if (v === "text")
    return m;
  if (k) {
    var y = pt(t, u), b;
    if (!u)
      b = ie(ie({}, i), {}, {
        className: Qe(i.className)
      });
    else {
      var h = Object.keys(t).reduce(function(A, l) {
        return l.split(".").forEach(function(r) {
          A.includes(r) || A.push(r);
        }), A;
      }, []), E = i.className && i.className.includes("token") ? ["token"] : [], w = i.className && E.concat(i.className.filter(function(A) {
        return !h.includes(A);
      }));
      b = ie(ie({}, i), {}, {
        className: Qe(w) || void 0,
        style: dt(i.className, Object.assign({}, i.style, o), t)
      });
    }
    var T = y(n.children);
    return /* @__PURE__ */ Q.createElement(k, lt({
      key: d
    }, b), T);
  }
}
const ft = function(e, n) {
  var t = e.listLanguages();
  return t.indexOf(n) !== -1;
};
var ht = ["language", "children", "style", "customStyle", "codeTagProps", "useInlineStyles", "showLineNumbers", "showInlineLineNumbers", "startingLineNumber", "lineNumberContainerStyle", "lineNumberStyle", "wrapLines", "wrapLongLines", "lineProps", "renderer", "PreTag", "CodeTag", "code", "astGenerator"];
function en(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    n && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function X(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? en(Object(t), !0).forEach(function(a) {
      An(e, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : en(Object(t)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return e;
}
var mt = /\n/g;
function vt(e) {
  return e.match(mt);
}
function yt(e) {
  var n = e.lines, t = e.startingLineNumber, a = e.style;
  return n.map(function(o, u) {
    var d = u + t;
    return /* @__PURE__ */ Q.createElement("span", {
      key: "line-".concat(u),
      className: "react-syntax-highlighter-line-number",
      style: typeof a == "function" ? a(d) : a
    }, "".concat(d, `
`));
  });
}
function bt(e) {
  var n = e.codeString, t = e.codeStyle, a = e.containerStyle, o = a === void 0 ? {
    float: "left",
    paddingRight: "10px"
  } : a, u = e.numberStyle, d = u === void 0 ? {} : u, i = e.startingLineNumber;
  return /* @__PURE__ */ Q.createElement("code", {
    style: Object.assign({}, t, o)
  }, yt({
    lines: n.replace(/\n$/, "").split(`
`),
    style: d,
    startingLineNumber: i
  }));
}
function xt(e) {
  return "".concat(e.toString().length, ".25em");
}
function Cn(e, n) {
  return {
    type: "element",
    tagName: "span",
    properties: {
      key: "line-number--".concat(e),
      className: ["comment", "linenumber", "react-syntax-highlighter-line-number"],
      style: n
    },
    children: [{
      type: "text",
      value: e
    }]
  };
}
function Ln(e, n, t) {
  var a = {
    display: "inline-block",
    minWidth: xt(t),
    paddingRight: "1em",
    textAlign: "right",
    userSelect: "none"
  }, o = typeof e == "function" ? e(n) : e, u = X(X({}, a), o);
  return u;
}
function ye(e) {
  var n = e.children, t = e.lineNumber, a = e.lineNumberStyle, o = e.largestLineNumber, u = e.showInlineLineNumbers, d = e.lineProps, i = d === void 0 ? {} : d, v = e.className, k = v === void 0 ? [] : v, m = e.showLineNumbers, y = e.wrapLongLines, b = typeof i == "function" ? i(t) : i;
  if (b.className = k, t && u) {
    var h = Ln(a, t, o);
    n.unshift(Cn(t, h));
  }
  return y & m && (b.style = X(X({}, b.style), {}, {
    display: "flex"
  })), {
    type: "element",
    tagName: "span",
    properties: b,
    children: n
  };
}
function En(e) {
  for (var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], a = 0; a < e.length; a++) {
    var o = e[a];
    if (o.type === "text")
      t.push(ye({
        children: [o],
        className: st(new Set(n))
      }));
    else if (o.children) {
      var u = n.concat(o.properties.className);
      En(o.children, u).forEach(function(d) {
        return t.push(d);
      });
    }
  }
  return t;
}
function wt(e, n, t, a, o, u, d, i, v) {
  var k, m = En(e.value), y = [], b = -1, h = 0;
  function E(c, s) {
    var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return ye({
      children: c,
      lineNumber: s,
      lineNumberStyle: i,
      largestLineNumber: d,
      showInlineLineNumbers: o,
      lineProps: t,
      className: f,
      showLineNumbers: a,
      wrapLongLines: v
    });
  }
  function w(c, s) {
    if (a && s && o) {
      var f = Ln(i, s, d);
      c.unshift(Cn(s, f));
    }
    return c;
  }
  function T(c, s) {
    var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return n || f.length > 0 ? E(c, s, f) : w(c, s);
  }
  for (var A = function() {
    var s = m[h], f = s.children[0].value, x = vt(f);
    if (x) {
      var p = f.split(`
`);
      p.forEach(function($, L) {
        var I = a && y.length + u, R = {
          type: "text",
          value: "".concat($, `
`)
        };
        if (L === 0) {
          var U = m.slice(b + 1, h).concat(ye({
            children: [R],
            className: s.properties.className
          })), B = T(U, I);
          y.push(B);
        } else if (L === p.length - 1) {
          var M = m[h + 1] && m[h + 1].children && m[h + 1].children[0], K = {
            type: "text",
            value: "".concat($)
          };
          if (M) {
            var F = ye({
              children: [K],
              className: s.properties.className
            });
            m.splice(h + 1, 0, F);
          } else {
            var O = [K], j = T(O, I, s.properties.className);
            y.push(j);
          }
        } else {
          var C = [R], _ = T(C, I, s.properties.className);
          y.push(_);
        }
      }), b = h;
    }
    h++;
  }; h < m.length; )
    A();
  if (b !== m.length - 1) {
    var l = m.slice(b + 1, m.length);
    if (l && l.length) {
      var r = a && y.length + u, g = T(l, r);
      y.push(g);
    }
  }
  return n ? y : (k = []).concat.apply(k, y);
}
function St(e) {
  var n = e.rows, t = e.stylesheet, a = e.useInlineStyles;
  return n.map(function(o, u) {
    return Fn({
      node: o,
      stylesheet: t,
      useInlineStyles: a,
      key: "code-segement".concat(u)
    });
  });
}
function Nn(e) {
  return e && typeof e.highlightAuto < "u";
}
function kt(e) {
  var n = e.astGenerator, t = e.language, a = e.code, o = e.defaultCodeValue;
  if (Nn(n)) {
    var u = ft(n, t);
    return t === "text" ? {
      value: o,
      language: "text"
    } : u ? n.highlight(t, a) : n.highlightAuto(a);
  }
  try {
    return t && t !== "text" ? {
      value: n.highlight(a, t)
    } : {
      value: o
    };
  } catch {
    return {
      value: o
    };
  }
}
function $t(e, n) {
  return function(a) {
    var o = a.language, u = a.children, d = a.style, i = d === void 0 ? n : d, v = a.customStyle, k = v === void 0 ? {} : v, m = a.codeTagProps, y = m === void 0 ? {
      className: o ? "language-".concat(o) : void 0,
      style: X(X({}, i['code[class*="language-"]']), i['code[class*="language-'.concat(o, '"]')])
    } : m, b = a.useInlineStyles, h = b === void 0 ? !0 : b, E = a.showLineNumbers, w = E === void 0 ? !1 : E, T = a.showInlineLineNumbers, A = T === void 0 ? !0 : T, l = a.startingLineNumber, r = l === void 0 ? 1 : l, g = a.lineNumberContainerStyle, c = a.lineNumberStyle, s = c === void 0 ? {} : c, f = a.wrapLines, x = a.wrapLongLines, p = x === void 0 ? !1 : x, $ = a.lineProps, L = $ === void 0 ? {} : $, I = a.renderer, R = a.PreTag, U = R === void 0 ? "pre" : R, B = a.CodeTag, M = B === void 0 ? "code" : B, K = a.code, F = K === void 0 ? (Array.isArray(u) ? u[0] : u) || "" : K, O = a.astGenerator, j = it(a, ht);
    O = O || e;
    var C = w ? /* @__PURE__ */ Q.createElement(bt, {
      containerStyle: g,
      codeStyle: y.style || {},
      numberStyle: s,
      startingLineNumber: r,
      codeString: F
    }) : null, _ = i.hljs || i['pre[class*="language-"]'] || {
      backgroundColor: "#fff"
    }, re = Nn(O) ? "hljs" : "prismjs", q = h ? Object.assign({}, j, {
      style: Object.assign({}, _, k)
    }) : Object.assign({}, j, {
      className: j.className ? "".concat(re, " ").concat(j.className) : re,
      style: Object.assign({}, k)
    });
    if (p ? y.style = X(X({}, y.style), {}, {
      whiteSpace: "pre-wrap"
    }) : y.style = X(X({}, y.style), {}, {
      whiteSpace: "pre"
    }), !O)
      return /* @__PURE__ */ Q.createElement(U, q, C, /* @__PURE__ */ Q.createElement(M, y, F));
    (f === void 0 && I || p) && (f = !0), I = I || St;
    var J = [{
      type: "text",
      value: F
    }], Z = kt({
      astGenerator: O,
      language: o,
      code: F,
      defaultCodeValue: J
    });
    Z.language === null && (Z.value = J);
    var Y = Z.value.length + r, ce = wt(Z, f, L, w, A, r, Y, s, p);
    return /* @__PURE__ */ Q.createElement(U, q, /* @__PURE__ */ Q.createElement(M, y, !A && C, I({
      rows: ce,
      stylesheet: i,
      useInlineStyles: h
    })));
  };
}
var At = Ct, Ft = Object.prototype.hasOwnProperty;
function Ct() {
  for (var e = {}, n = 0; n < arguments.length; n++) {
    var t = arguments[n];
    for (var a in t)
      Ft.call(t, a) && (e[a] = t[a]);
  }
  return e;
}
var Tn = jn, Ie = jn.prototype;
Ie.space = null;
Ie.normal = {};
Ie.property = {};
function jn(e, n, t) {
  this.property = e, this.normal = n, t && (this.space = t);
}
var nn = At, Lt = Tn, Et = Nt;
function Nt(e) {
  for (var n = e.length, t = [], a = [], o = -1, u, d; ++o < n; )
    u = e[o], t.push(u.property), a.push(u.normal), d = u.space;
  return new Lt(
    nn.apply(null, t),
    nn.apply(null, a),
    d
  );
}
var _e = Tt;
function Tt(e) {
  return e.toLowerCase();
}
var On = In, V = In.prototype;
V.space = null;
V.attribute = null;
V.property = null;
V.boolean = !1;
V.booleanish = !1;
V.overloadedBoolean = !1;
V.number = !1;
V.commaSeparated = !1;
V.spaceSeparated = !1;
V.commaOrSpaceSeparated = !1;
V.mustUseProperty = !1;
V.defined = !1;
function In(e, n) {
  this.property = e, this.attribute = n;
}
var P = {}, jt = 0;
P.boolean = ae();
P.booleanish = ae();
P.overloadedBoolean = ae();
P.number = ae();
P.spaceSeparated = ae();
P.commaSeparated = ae();
P.commaOrSpaceSeparated = ae();
function ae() {
  return Math.pow(2, ++jt);
}
var _n = On, tn = P, zn = ze;
ze.prototype = new _n();
ze.prototype.defined = !0;
var Rn = [
  "boolean",
  "booleanish",
  "overloadedBoolean",
  "number",
  "commaSeparated",
  "spaceSeparated",
  "commaOrSpaceSeparated"
], Ot = Rn.length;
function ze(e, n, t, a) {
  var o = -1, u;
  for (an(this, "space", a), _n.call(this, e, n); ++o < Ot; )
    u = Rn[o], an(this, u, (t & tn[u]) === tn[u]);
}
function an(e, n, t) {
  t && (e[n] = t);
}
var rn = _e, It = Tn, _t = zn, pe = zt;
function zt(e) {
  var n = e.space, t = e.mustUseProperty || [], a = e.attributes || {}, o = e.properties, u = e.transform, d = {}, i = {}, v, k;
  for (v in o)
    k = new _t(
      v,
      u(a, v),
      o[v],
      n
    ), t.indexOf(v) !== -1 && (k.mustUseProperty = !0), d[v] = k, i[rn(v)] = v, i[rn(k.attribute)] = v;
  return new It(d, i, n);
}
var Rt = pe, Mt = Rt({
  space: "xlink",
  transform: Dt,
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
});
function Dt(e, n) {
  return "xlink:" + n.slice(5).toLowerCase();
}
var Bt = pe, qt = Bt({
  space: "xml",
  transform: Ht,
  properties: {
    xmlLang: null,
    xmlBase: null,
    xmlSpace: null
  }
});
function Ht(e, n) {
  return "xml:" + n.slice(3).toLowerCase();
}
var Ut = Wt;
function Wt(e, n) {
  return n in e ? e[n] : n;
}
var Zt = Ut, Mn = Gt;
function Gt(e, n) {
  return Zt(e, n.toLowerCase());
}
var Vt = pe, Kt = Mn, Jt = Vt({
  space: "xmlns",
  attributes: {
    xmlnsxlink: "xmlns:xlink"
  },
  transform: Kt,
  properties: {
    xmlns: null,
    xmlnsXLink: null
  }
}), Re = P, Yt = pe, H = Re.booleanish, G = Re.number, te = Re.spaceSeparated, Xt = Yt({
  transform: Pt,
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: H,
    ariaAutoComplete: null,
    ariaBusy: H,
    ariaChecked: H,
    ariaColCount: G,
    ariaColIndex: G,
    ariaColSpan: G,
    ariaControls: te,
    ariaCurrent: null,
    ariaDescribedBy: te,
    ariaDetails: null,
    ariaDisabled: H,
    ariaDropEffect: te,
    ariaErrorMessage: null,
    ariaExpanded: H,
    ariaFlowTo: te,
    ariaGrabbed: H,
    ariaHasPopup: null,
    ariaHidden: H,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: te,
    ariaLevel: G,
    ariaLive: null,
    ariaModal: H,
    ariaMultiLine: H,
    ariaMultiSelectable: H,
    ariaOrientation: null,
    ariaOwns: te,
    ariaPlaceholder: null,
    ariaPosInSet: G,
    ariaPressed: H,
    ariaReadOnly: H,
    ariaRelevant: null,
    ariaRequired: H,
    ariaRoleDescription: te,
    ariaRowCount: G,
    ariaRowIndex: G,
    ariaRowSpan: G,
    ariaSelected: H,
    ariaSetSize: G,
    ariaSort: null,
    ariaValueMax: G,
    ariaValueMin: G,
    ariaValueNow: G,
    ariaValueText: null,
    role: null
  }
});
function Pt(e, n) {
  return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
}
var se = P, Qt = pe, ea = Mn, S = se.boolean, na = se.overloadedBoolean, ue = se.booleanish, N = se.number, D = se.spaceSeparated, me = se.commaSeparated, ta = Qt({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: ea,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: me,
    acceptCharset: D,
    accessKey: D,
    action: null,
    allow: null,
    allowFullScreen: S,
    allowPaymentRequest: S,
    allowUserMedia: S,
    alt: null,
    as: null,
    async: S,
    autoCapitalize: null,
    autoComplete: D,
    autoFocus: S,
    autoPlay: S,
    capture: S,
    charSet: null,
    checked: S,
    cite: null,
    className: D,
    cols: N,
    colSpan: null,
    content: null,
    contentEditable: ue,
    controls: S,
    controlsList: D,
    coords: N | me,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: S,
    defer: S,
    dir: null,
    dirName: null,
    disabled: S,
    download: na,
    draggable: ue,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: S,
    formTarget: null,
    headers: D,
    height: N,
    hidden: S,
    high: N,
    href: null,
    hrefLang: null,
    htmlFor: D,
    httpEquiv: D,
    id: null,
    imageSizes: null,
    imageSrcSet: me,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: S,
    itemId: null,
    itemProp: D,
    itemRef: D,
    itemScope: S,
    itemType: D,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: S,
    low: N,
    manifest: null,
    max: null,
    maxLength: N,
    media: null,
    method: null,
    min: null,
    minLength: N,
    multiple: S,
    muted: S,
    name: null,
    nonce: null,
    noModule: S,
    noValidate: S,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextMenu: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: S,
    optimum: N,
    pattern: null,
    ping: D,
    placeholder: null,
    playsInline: S,
    poster: null,
    preload: null,
    readOnly: S,
    referrerPolicy: null,
    rel: D,
    required: S,
    reversed: S,
    rows: N,
    rowSpan: N,
    sandbox: D,
    scope: null,
    scoped: S,
    seamless: S,
    selected: S,
    shape: null,
    size: N,
    sizes: null,
    slot: null,
    span: N,
    spellCheck: ue,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: me,
    start: N,
    step: null,
    style: null,
    tabIndex: N,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: S,
    useMap: null,
    value: ue,
    width: N,
    wrap: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: D,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: N,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: N,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: S,
    // Lists. Use CSS to reduce space between items instead
    declare: S,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: N,
    // `<img>` and `<object>`
    leftMargin: N,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: N,
    // `<body>`
    marginWidth: N,
    // `<body>`
    noResize: S,
    // `<frame>`
    noHref: S,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: S,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: S,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: N,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: ue,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: N,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: N,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: S,
    disableRemotePlayback: S,
    prefix: null,
    property: null,
    results: N,
    security: null,
    unselectable: null
  }
}), aa = Et, ra = Mt, oa = qt, la = Jt, ia = Xt, sa = ta, ca = aa([oa, ra, la, ia, sa]), ua = _e, ga = zn, da = On, Me = "data", pa = ma, fa = /^data[-\w.:]+$/i, Dn = /-[a-z]/g, ha = /[A-Z]/g;
function ma(e, n) {
  var t = ua(n), a = n, o = da;
  return t in e.normal ? e.property[e.normal[t]] : (t.length > 4 && t.slice(0, 4) === Me && fa.test(n) && (n.charAt(4) === "-" ? a = va(n) : n = ya(n), o = ga), new o(a, n));
}
function va(e) {
  var n = e.slice(5).replace(Dn, xa);
  return Me + n.charAt(0).toUpperCase() + n.slice(1);
}
function ya(e) {
  var n = e.slice(4);
  return Dn.test(n) ? e : (n = n.replace(ha, ba), n.charAt(0) !== "-" && (n = "-" + n), Me + n);
}
function ba(e) {
  return "-" + e.toLowerCase();
}
function xa(e) {
  return e.charAt(1).toUpperCase();
}
var wa = Sa, on = /[#.]/g;
function Sa(e, n) {
  for (var t = e || "", a = n || "div", o = {}, u = 0, d, i, v; u < t.length; )
    on.lastIndex = u, v = on.exec(t), d = t.slice(u, v ? v.index : t.length), d && (i ? i === "#" ? o.id = d : o.className ? o.className.push(d) : o.className = [d] : a = d, u += d.length), v && (i = v[0], u++);
  return { type: "element", tagName: a, properties: o, children: [] };
}
var De = {};
De.parse = Aa;
De.stringify = Fa;
var ln = "", ka = " ", $a = /[ \t\n\r\f]+/g;
function Aa(e) {
  var n = String(e || ln).trim();
  return n === ln ? [] : n.split($a);
}
function Fa(e) {
  return e.join(ka).trim();
}
var Be = {};
Be.parse = Ca;
Be.stringify = La;
var je = ",", sn = " ", ge = "";
function Ca(e) {
  for (var n = [], t = String(e || ge), a = t.indexOf(je), o = 0, u = !1, d; !u; )
    a === -1 && (a = t.length, u = !0), d = t.slice(o, a).trim(), (d || !u) && n.push(d), o = a + 1, a = t.indexOf(je, o);
  return n;
}
function La(e, n) {
  var t = n || {}, a = t.padLeft === !1 ? ge : sn, o = t.padRight ? sn : ge;
  return e[e.length - 1] === ge && (e = e.concat(ge)), e.join(o + je + a).trim();
}
var Ea = pa, cn = _e, Na = wa, un = De.parse, gn = Be.parse, Ta = Oa, ja = {}.hasOwnProperty;
function Oa(e, n, t) {
  var a = t ? Ma(t) : null;
  return o;
  function o(d, i) {
    var v = Na(d, n), k = Array.prototype.slice.call(arguments, 2), m = v.tagName.toLowerCase(), y;
    if (v.tagName = a && ja.call(a, m) ? a[m] : m, i && Ia(i, v) && (k.unshift(i), i = null), i)
      for (y in i)
        u(v.properties, y, i[y]);
    return Bn(v.children, k), v.tagName === "template" && (v.content = { type: "root", children: v.children }, v.children = []), v;
  }
  function u(d, i, v) {
    var k, m, y;
    v == null || v !== v || (k = Ea(e, i), m = k.property, y = v, typeof y == "string" && (k.spaceSeparated ? y = un(y) : k.commaSeparated ? y = gn(y) : k.commaOrSpaceSeparated && (y = un(gn(y).join(" ")))), m === "style" && typeof v != "string" && (y = Ra(y)), m === "className" && d.className && (y = d.className.concat(y)), d[m] = za(k, m, y));
  }
}
function Ia(e, n) {
  return typeof e == "string" || "length" in e || _a(n.tagName, e);
}
function _a(e, n) {
  var t = n.type;
  return e === "input" || !t || typeof t != "string" ? !1 : typeof n.children == "object" && "length" in n.children ? !0 : (t = t.toLowerCase(), e === "button" ? t !== "menu" && t !== "submit" && t !== "reset" && t !== "button" : "value" in n);
}
function Bn(e, n) {
  var t, a;
  if (typeof n == "string" || typeof n == "number") {
    e.push({ type: "text", value: String(n) });
    return;
  }
  if (typeof n == "object" && "length" in n) {
    for (t = -1, a = n.length; ++t < a; )
      Bn(e, n[t]);
    return;
  }
  if (typeof n != "object" || !("type" in n))
    throw new Error("Expected node, nodes, or string, got `" + n + "`");
  e.push(n);
}
function za(e, n, t) {
  var a, o, u;
  if (typeof t != "object" || !("length" in t))
    return dn(e, n, t);
  for (o = t.length, a = -1, u = []; ++a < o; )
    u[a] = dn(e, n, t[a]);
  return u;
}
function dn(e, n, t) {
  var a = t;
  return e.number || e.positiveNumber ? !isNaN(a) && a !== "" && (a = Number(a)) : (e.boolean || e.overloadedBoolean) && typeof a == "string" && (a === "" || cn(t) === cn(n)) && (a = !0), a;
}
function Ra(e) {
  var n = [], t;
  for (t in e)
    n.push([t, e[t]].join(": "));
  return n.join("; ");
}
function Ma(e) {
  for (var n = e.length, t = -1, a = {}, o; ++t < n; )
    o = e[t], a[o.toLowerCase()] = o;
  return a;
}
var Da = ca, Ba = Ta, qn = Ba(Da, "div");
qn.displayName = "html";
var qa = qn, Ha = qa;
const Ua = "Æ", Wa = "&", Za = "Á", Ga = "Â", Va = "À", Ka = "Å", Ja = "Ã", Ya = "Ä", Xa = "©", Pa = "Ç", Qa = "Ð", er = "É", nr = "Ê", tr = "È", ar = "Ë", rr = ">", or = "Í", lr = "Î", ir = "Ì", sr = "Ï", cr = "<", ur = "Ñ", gr = "Ó", dr = "Ô", pr = "Ò", fr = "Ø", hr = "Õ", mr = "Ö", vr = '"', yr = "®", br = "Þ", xr = "Ú", wr = "Û", Sr = "Ù", kr = "Ü", $r = "Ý", Ar = "á", Fr = "â", Cr = "´", Lr = "æ", Er = "à", Nr = "&", Tr = "å", jr = "ã", Or = "ä", Ir = "¦", _r = "ç", zr = "¸", Rr = "¢", Mr = "©", Dr = "¤", Br = "°", qr = "÷", Hr = "é", Ur = "ê", Wr = "è", Zr = "ð", Gr = "ë", Vr = "½", Kr = "¼", Jr = "¾", Yr = ">", Xr = "í", Pr = "î", Qr = "¡", eo = "ì", no = "¿", to = "ï", ao = "«", ro = "<", oo = "¯", lo = "µ", io = "·", so = " ", co = "¬", uo = "ñ", go = "ó", po = "ô", fo = "ò", ho = "ª", mo = "º", vo = "ø", yo = "õ", bo = "ö", xo = "¶", wo = "±", So = "£", ko = '"', $o = "»", Ao = "®", Fo = "§", Co = "­", Lo = "¹", Eo = "²", No = "³", To = "ß", jo = "þ", Oo = "×", Io = "ú", _o = "û", zo = "ù", Ro = "¨", Mo = "ü", Do = "ý", Bo = "¥", qo = "ÿ", Ho = {
  AElig: Ua,
  AMP: Wa,
  Aacute: Za,
  Acirc: Ga,
  Agrave: Va,
  Aring: Ka,
  Atilde: Ja,
  Auml: Ya,
  COPY: Xa,
  Ccedil: Pa,
  ETH: Qa,
  Eacute: er,
  Ecirc: nr,
  Egrave: tr,
  Euml: ar,
  GT: rr,
  Iacute: or,
  Icirc: lr,
  Igrave: ir,
  Iuml: sr,
  LT: cr,
  Ntilde: ur,
  Oacute: gr,
  Ocirc: dr,
  Ograve: pr,
  Oslash: fr,
  Otilde: hr,
  Ouml: mr,
  QUOT: vr,
  REG: yr,
  THORN: br,
  Uacute: xr,
  Ucirc: wr,
  Ugrave: Sr,
  Uuml: kr,
  Yacute: $r,
  aacute: Ar,
  acirc: Fr,
  acute: Cr,
  aelig: Lr,
  agrave: Er,
  amp: Nr,
  aring: Tr,
  atilde: jr,
  auml: Or,
  brvbar: Ir,
  ccedil: _r,
  cedil: zr,
  cent: Rr,
  copy: Mr,
  curren: Dr,
  deg: Br,
  divide: qr,
  eacute: Hr,
  ecirc: Ur,
  egrave: Wr,
  eth: Zr,
  euml: Gr,
  frac12: Vr,
  frac14: Kr,
  frac34: Jr,
  gt: Yr,
  iacute: Xr,
  icirc: Pr,
  iexcl: Qr,
  igrave: eo,
  iquest: no,
  iuml: to,
  laquo: ao,
  lt: ro,
  macr: oo,
  micro: lo,
  middot: io,
  nbsp: so,
  not: co,
  ntilde: uo,
  oacute: go,
  ocirc: po,
  ograve: fo,
  ordf: ho,
  ordm: mo,
  oslash: vo,
  otilde: yo,
  ouml: bo,
  para: xo,
  plusmn: wo,
  pound: So,
  quot: ko,
  raquo: $o,
  reg: Ao,
  sect: Fo,
  shy: Co,
  sup1: Lo,
  sup2: Eo,
  sup3: No,
  szlig: To,
  thorn: jo,
  times: Oo,
  uacute: Io,
  ucirc: _o,
  ugrave: zo,
  uml: Ro,
  uuml: Mo,
  yacute: Do,
  yen: Bo,
  yuml: qo
}, Uo = {
  0: "�",
  128: "€",
  130: "‚",
  131: "ƒ",
  132: "„",
  133: "…",
  134: "†",
  135: "‡",
  136: "ˆ",
  137: "‰",
  138: "Š",
  139: "‹",
  140: "Œ",
  142: "Ž",
  145: "‘",
  146: "’",
  147: "“",
  148: "”",
  149: "•",
  150: "–",
  151: "—",
  152: "˜",
  153: "™",
  154: "š",
  155: "›",
  156: "œ",
  158: "ž",
  159: "Ÿ"
};
var Hn = Wo;
function Wo(e) {
  var n = typeof e == "string" ? e.charCodeAt(0) : e;
  return n >= 48 && n <= 57;
}
var Zo = Go;
function Go(e) {
  var n = typeof e == "string" ? e.charCodeAt(0) : e;
  return n >= 97 && n <= 102 || n >= 65 && n <= 70 || n >= 48 && n <= 57;
}
var Vo = Ko;
function Ko(e) {
  var n = typeof e == "string" ? e.charCodeAt(0) : e;
  return n >= 97 && n <= 122 || n >= 65 && n <= 90;
}
var Jo = Vo, Yo = Hn, Xo = Po;
function Po(e) {
  return Jo(e) || Yo(e);
}
var ve, Qo = 59, el = nl;
function nl(e) {
  var n = "&" + e + ";", t;
  return ve = ve || document.createElement("i"), ve.innerHTML = n, t = ve.textContent, t.charCodeAt(t.length - 1) === Qo && e !== "semi" || t === n ? !1 : t;
}
var pn = Ho, fn = Uo, tl = Hn, al = Zo, Un = Xo, rl = el, ol = yl, ll = {}.hasOwnProperty, oe = String.fromCharCode, il = Function.prototype, hn = {
  warning: null,
  reference: null,
  text: null,
  warningContext: null,
  referenceContext: null,
  textContext: null,
  position: {},
  additional: null,
  attribute: !1,
  nonTerminated: !0
}, sl = 9, mn = 10, cl = 12, ul = 32, vn = 38, gl = 59, dl = 60, pl = 61, fl = 35, hl = 88, ml = 120, vl = 65533, le = "named", qe = "hexadecimal", He = "decimal", Ue = {};
Ue[qe] = 16;
Ue[He] = 10;
var xe = {};
xe[le] = Un;
xe[He] = tl;
xe[qe] = al;
var Wn = 1, Zn = 2, Gn = 3, Vn = 4, Kn = 5, Oe = 6, Jn = 7, ne = {};
ne[Wn] = "Named character references must be terminated by a semicolon";
ne[Zn] = "Numeric character references must be terminated by a semicolon";
ne[Gn] = "Named character references cannot be empty";
ne[Vn] = "Numeric character references cannot be empty";
ne[Kn] = "Named character references must be known";
ne[Oe] = "Numeric character references cannot be disallowed";
ne[Jn] = "Numeric character references cannot be outside the permissible Unicode range";
function yl(e, n) {
  var t = {}, a, o;
  n || (n = {});
  for (o in hn)
    a = n[o], t[o] = a ?? hn[o];
  return (t.position.indent || t.position.start) && (t.indent = t.position.indent || [], t.position = t.position.start), bl(e, t);
}
function bl(e, n) {
  var t = n.additional, a = n.nonTerminated, o = n.text, u = n.reference, d = n.warning, i = n.textContext, v = n.referenceContext, k = n.warningContext, m = n.position, y = n.indent || [], b = e.length, h = 0, E = -1, w = m.column || 1, T = m.line || 1, A = "", l = [], r, g, c, s, f, x, p, $, L, I, R, U, B, M, K, F, O, j, C;
  for (typeof t == "string" && (t = t.charCodeAt(0)), F = _(), $ = d ? re : il, h--, b++; ++h < b; )
    if (f === mn && (w = y[E] || 1), f = e.charCodeAt(h), f === vn) {
      if (p = e.charCodeAt(h + 1), p === sl || p === mn || p === cl || p === ul || p === vn || p === dl || p !== p || t && p === t) {
        A += oe(f), w++;
        continue;
      }
      for (B = h + 1, U = B, C = B, p === fl ? (C = ++U, p = e.charCodeAt(C), p === hl || p === ml ? (M = qe, C = ++U) : M = He) : M = le, r = "", R = "", s = "", K = xe[M], C--; ++C < b && (p = e.charCodeAt(C), !!K(p)); )
        s += oe(p), M === le && ll.call(pn, s) && (r = s, R = pn[s]);
      c = e.charCodeAt(C) === gl, c && (C++, g = M === le ? rl(s) : !1, g && (r = s, R = g)), j = 1 + C - B, !c && !a || (s ? M === le ? (c && !R ? $(Kn, 1) : (r !== s && (C = U + r.length, j = 1 + C - U, c = !1), c || (L = r ? Wn : Gn, n.attribute ? (p = e.charCodeAt(C), p === pl ? ($(L, j), R = null) : Un(p) ? R = null : $(L, j)) : $(L, j))), x = R) : (c || $(Zn, j), x = parseInt(s, Ue[M]), xl(x) ? ($(Jn, j), x = oe(vl)) : x in fn ? ($(Oe, j), x = fn[x]) : (I = "", wl(x) && $(Oe, j), x > 65535 && (x -= 65536, I += oe(x >>> 10 | 55296), x = 56320 | x & 1023), x = I + oe(x))) : M !== le && $(Vn, j)), x ? (q(), F = _(), h = C - 1, w += C - B + 1, l.push(x), O = _(), O.offset++, u && u.call(
        v,
        x,
        { start: F, end: O },
        e.slice(B - 1, C)
      ), F = O) : (s = e.slice(B - 1, C), A += s, w += s.length, h = C - 1);
    } else
      f === 10 && (T++, E++, w = 0), f === f ? (A += oe(f), w++) : q();
  return l.join("");
  function _() {
    return {
      line: T,
      column: w,
      offset: h + (m.offset || 0)
    };
  }
  function re(J, Z) {
    var Y = _();
    Y.column += Z, Y.offset += Z, d.call(k, ne[J], Y, J);
  }
  function q() {
    A && (l.push(A), o && o.call(i, A, { start: F, end: _() }), A = "");
  }
}
function xl(e) {
  return e >= 55296 && e <= 57343 || e > 1114111;
}
function wl(e) {
  return e >= 1 && e <= 8 || e === 11 || e >= 13 && e <= 31 || e >= 127 && e <= 159 || e >= 64976 && e <= 65007 || (e & 65535) === 65535 || (e & 65535) === 65534;
}
var Yn = { exports: {} };
(function(e) {
  var n = typeof window < "u" ? window : typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope ? self : {};
  /**
   * Prism: Lightweight, robust, elegant syntax highlighting
   *
   * @license MIT <https://opensource.org/licenses/MIT>
   * @author Lea Verou <https://lea.verou.me>
   * @namespace
   * @public
   */
  var t = function(a) {
    var o = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, u = 0, d = {}, i = {
      /**
       * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
       * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
       * additional languages or plugins yourself.
       *
       * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
       *
       * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
       * empty Prism object into the global scope before loading the Prism script like this:
       *
       * ```js
       * window.Prism = window.Prism || {};
       * Prism.manual = true;
       * // add a new <script> to load Prism's script
       * ```
       *
       * @default false
       * @type {boolean}
       * @memberof Prism
       * @public
       */
      manual: a.Prism && a.Prism.manual,
      /**
       * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
       * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
       * own worker, you don't want it to do this.
       *
       * By setting this value to `true`, Prism will not add its own listeners to the worker.
       *
       * You obviously have to change this value before Prism executes. To do this, you can add an
       * empty Prism object into the global scope before loading the Prism script like this:
       *
       * ```js
       * window.Prism = window.Prism || {};
       * Prism.disableWorkerMessageHandler = true;
       * // Load Prism's script
       * ```
       *
       * @default false
       * @type {boolean}
       * @memberof Prism
       * @public
       */
      disableWorkerMessageHandler: a.Prism && a.Prism.disableWorkerMessageHandler,
      /**
       * A namespace for utility methods.
       *
       * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
       * change or disappear at any time.
       *
       * @namespace
       * @memberof Prism
       */
      util: {
        encode: function l(r) {
          return r instanceof v ? new v(r.type, l(r.content), r.alias) : Array.isArray(r) ? r.map(l) : r.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
        },
        /**
         * Returns the name of the type of the given value.
         *
         * @param {any} o
         * @returns {string}
         * @example
         * type(null)      === 'Null'
         * type(undefined) === 'Undefined'
         * type(123)       === 'Number'
         * type('foo')     === 'String'
         * type(true)      === 'Boolean'
         * type([1, 2])    === 'Array'
         * type({})        === 'Object'
         * type(String)    === 'Function'
         * type(/abc+/)    === 'RegExp'
         */
        type: function(l) {
          return Object.prototype.toString.call(l).slice(8, -1);
        },
        /**
         * Returns a unique number for the given object. Later calls will still return the same number.
         *
         * @param {Object} obj
         * @returns {number}
         */
        objId: function(l) {
          return l.__id || Object.defineProperty(l, "__id", { value: ++u }), l.__id;
        },
        /**
         * Creates a deep clone of the given object.
         *
         * The main intended use of this function is to clone language definitions.
         *
         * @param {T} o
         * @param {Record<number, any>} [visited]
         * @returns {T}
         * @template T
         */
        clone: function l(r, g) {
          g = g || {};
          var c, s;
          switch (i.util.type(r)) {
            case "Object":
              if (s = i.util.objId(r), g[s])
                return g[s];
              c = /** @type {Record<string, any>} */
              {}, g[s] = c;
              for (var f in r)
                r.hasOwnProperty(f) && (c[f] = l(r[f], g));
              return (
                /** @type {any} */
                c
              );
            case "Array":
              return s = i.util.objId(r), g[s] ? g[s] : (c = [], g[s] = c, /** @type {Array} */
              /** @type {any} */
              r.forEach(function(x, p) {
                c[p] = l(x, g);
              }), /** @type {any} */
              c);
            default:
              return r;
          }
        },
        /**
         * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
         *
         * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
         *
         * @param {Element} element
         * @returns {string}
         */
        getLanguage: function(l) {
          for (; l; ) {
            var r = o.exec(l.className);
            if (r)
              return r[1].toLowerCase();
            l = l.parentElement;
          }
          return "none";
        },
        /**
         * Sets the Prism `language-xxxx` class of the given element.
         *
         * @param {Element} element
         * @param {string} language
         * @returns {void}
         */
        setLanguage: function(l, r) {
          l.className = l.className.replace(RegExp(o, "gi"), ""), l.classList.add("language-" + r);
        },
        /**
         * Returns the script element that is currently executing.
         *
         * This does __not__ work for line script element.
         *
         * @returns {HTMLScriptElement | null}
         */
        currentScript: function() {
          if (typeof document > "u")
            return null;
          if ("currentScript" in document)
            return (
              /** @type {any} */
              document.currentScript
            );
          try {
            throw new Error();
          } catch (c) {
            var l = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(c.stack) || [])[1];
            if (l) {
              var r = document.getElementsByTagName("script");
              for (var g in r)
                if (r[g].src == l)
                  return r[g];
            }
            return null;
          }
        },
        /**
         * Returns whether a given class is active for `element`.
         *
         * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
         * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
         * given class is just the given class with a `no-` prefix.
         *
         * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
         * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
         * ancestors have the given class or the negated version of it, then the default activation will be returned.
         *
         * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
         * version of it, the class is considered active.
         *
         * @param {Element} element
         * @param {string} className
         * @param {boolean} [defaultActivation=false]
         * @returns {boolean}
         */
        isActive: function(l, r, g) {
          for (var c = "no-" + r; l; ) {
            var s = l.classList;
            if (s.contains(r))
              return !0;
            if (s.contains(c))
              return !1;
            l = l.parentElement;
          }
          return !!g;
        }
      },
      /**
       * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
       *
       * @namespace
       * @memberof Prism
       * @public
       */
      languages: {
        /**
         * The grammar for plain, unformatted text.
         */
        plain: d,
        plaintext: d,
        text: d,
        txt: d,
        /**
         * Creates a deep copy of the language with the given id and appends the given tokens.
         *
         * If a token in `redef` also appears in the copied language, then the existing token in the copied language
         * will be overwritten at its original position.
         *
         * ## Best practices
         *
         * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
         * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
         * understand the language definition because, normally, the order of tokens matters in Prism grammars.
         *
         * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
         * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
         *
         * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
         * @param {Grammar} redef The new tokens to append.
         * @returns {Grammar} The new language created.
         * @public
         * @example
         * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
         *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
         *     // at its original position
         *     'comment': { ... },
         *     // CSS doesn't have a 'color' token, so this token will be appended
         *     'color': /\b(?:red|green|blue)\b/
         * });
         */
        extend: function(l, r) {
          var g = i.util.clone(i.languages[l]);
          for (var c in r)
            g[c] = r[c];
          return g;
        },
        /**
         * Inserts tokens _before_ another token in a language definition or any other grammar.
         *
         * ## Usage
         *
         * This helper method makes it easy to modify existing languages. For example, the CSS language definition
         * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
         * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
         * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
         * this:
         *
         * ```js
         * Prism.languages.markup.style = {
         *     // token
         * };
         * ```
         *
         * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
         * before existing tokens. For the CSS example above, you would use it like this:
         *
         * ```js
         * Prism.languages.insertBefore('markup', 'cdata', {
         *     'style': {
         *         // token
         *     }
         * });
         * ```
         *
         * ## Special cases
         *
         * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
         * will be ignored.
         *
         * This behavior can be used to insert tokens after `before`:
         *
         * ```js
         * Prism.languages.insertBefore('markup', 'comment', {
         *     'comment': Prism.languages.markup.comment,
         *     // tokens after 'comment'
         * });
         * ```
         *
         * ## Limitations
         *
         * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
         * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
         * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
         * deleting properties which is necessary to insert at arbitrary positions.
         *
         * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
         * Instead, it will create a new object and replace all references to the target object with the new one. This
         * can be done without temporarily deleting properties, so the iteration order is well-defined.
         *
         * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
         * you hold the target object in a variable, then the value of the variable will not change.
         *
         * ```js
         * var oldMarkup = Prism.languages.markup;
         * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
         *
         * assert(oldMarkup !== Prism.languages.markup);
         * assert(newMarkup === Prism.languages.markup);
         * ```
         *
         * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
         * object to be modified.
         * @param {string} before The key to insert before.
         * @param {Grammar} insert An object containing the key-value pairs to be inserted.
         * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
         * object to be modified.
         *
         * Defaults to `Prism.languages`.
         * @returns {Grammar} The new grammar object.
         * @public
         */
        insertBefore: function(l, r, g, c) {
          c = c || /** @type {any} */
          i.languages;
          var s = c[l], f = {};
          for (var x in s)
            if (s.hasOwnProperty(x)) {
              if (x == r)
                for (var p in g)
                  g.hasOwnProperty(p) && (f[p] = g[p]);
              g.hasOwnProperty(x) || (f[x] = s[x]);
            }
          var $ = c[l];
          return c[l] = f, i.languages.DFS(i.languages, function(L, I) {
            I === $ && L != l && (this[L] = f);
          }), f;
        },
        // Traverse a language definition with Depth First Search
        DFS: function l(r, g, c, s) {
          s = s || {};
          var f = i.util.objId;
          for (var x in r)
            if (r.hasOwnProperty(x)) {
              g.call(r, x, r[x], c || x);
              var p = r[x], $ = i.util.type(p);
              $ === "Object" && !s[f(p)] ? (s[f(p)] = !0, l(p, g, null, s)) : $ === "Array" && !s[f(p)] && (s[f(p)] = !0, l(p, g, x, s));
            }
        }
      },
      plugins: {},
      /**
       * This is the most high-level function in Prism’s API.
       * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
       * each one of them.
       *
       * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
       *
       * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
       * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
       * @memberof Prism
       * @public
       */
      highlightAll: function(l, r) {
        i.highlightAllUnder(document, l, r);
      },
      /**
       * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
       * {@link Prism.highlightElement} on each one of them.
       *
       * The following hooks will be run:
       * 1. `before-highlightall`
       * 2. `before-all-elements-highlight`
       * 3. All hooks of {@link Prism.highlightElement} for each element.
       *
       * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
       * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
       * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
       * @memberof Prism
       * @public
       */
      highlightAllUnder: function(l, r, g) {
        var c = {
          callback: g,
          container: l,
          selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
        };
        i.hooks.run("before-highlightall", c), c.elements = Array.prototype.slice.apply(c.container.querySelectorAll(c.selector)), i.hooks.run("before-all-elements-highlight", c);
        for (var s = 0, f; f = c.elements[s++]; )
          i.highlightElement(f, r === !0, c.callback);
      },
      /**
       * Highlights the code inside a single element.
       *
       * The following hooks will be run:
       * 1. `before-sanity-check`
       * 2. `before-highlight`
       * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
       * 4. `before-insert`
       * 5. `after-highlight`
       * 6. `complete`
       *
       * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
       * the element's language.
       *
       * @param {Element} element The element containing the code.
       * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
       * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
       * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
       * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
       *
       * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
       * asynchronous highlighting to work. You can build your own bundle on the
       * [Download page](https://prismjs.com/download.html).
       * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
       * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
       * @memberof Prism
       * @public
       */
      highlightElement: function(l, r, g) {
        var c = i.util.getLanguage(l), s = i.languages[c];
        i.util.setLanguage(l, c);
        var f = l.parentElement;
        f && f.nodeName.toLowerCase() === "pre" && i.util.setLanguage(f, c);
        var x = l.textContent, p = {
          element: l,
          language: c,
          grammar: s,
          code: x
        };
        function $(I) {
          p.highlightedCode = I, i.hooks.run("before-insert", p), p.element.innerHTML = p.highlightedCode, i.hooks.run("after-highlight", p), i.hooks.run("complete", p), g && g.call(p.element);
        }
        if (i.hooks.run("before-sanity-check", p), f = p.element.parentElement, f && f.nodeName.toLowerCase() === "pre" && !f.hasAttribute("tabindex") && f.setAttribute("tabindex", "0"), !p.code) {
          i.hooks.run("complete", p), g && g.call(p.element);
          return;
        }
        if (i.hooks.run("before-highlight", p), !p.grammar) {
          $(i.util.encode(p.code));
          return;
        }
        if (r && a.Worker) {
          var L = new Worker(i.filename);
          L.onmessage = function(I) {
            $(I.data);
          }, L.postMessage(JSON.stringify({
            language: p.language,
            code: p.code,
            immediateClose: !0
          }));
        } else
          $(i.highlight(p.code, p.grammar, p.language));
      },
      /**
       * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
       * and the language definitions to use, and returns a string with the HTML produced.
       *
       * The following hooks will be run:
       * 1. `before-tokenize`
       * 2. `after-tokenize`
       * 3. `wrap`: On each {@link Token}.
       *
       * @param {string} text A string with the code to be highlighted.
       * @param {Grammar} grammar An object containing the tokens to use.
       *
       * Usually a language definition like `Prism.languages.markup`.
       * @param {string} language The name of the language definition passed to `grammar`.
       * @returns {string} The highlighted HTML.
       * @memberof Prism
       * @public
       * @example
       * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
       */
      highlight: function(l, r, g) {
        var c = {
          code: l,
          grammar: r,
          language: g
        };
        if (i.hooks.run("before-tokenize", c), !c.grammar)
          throw new Error('The language "' + c.language + '" has no grammar.');
        return c.tokens = i.tokenize(c.code, c.grammar), i.hooks.run("after-tokenize", c), v.stringify(i.util.encode(c.tokens), c.language);
      },
      /**
       * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
       * and the language definitions to use, and returns an array with the tokenized code.
       *
       * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
       *
       * This method could be useful in other contexts as well, as a very crude parser.
       *
       * @param {string} text A string with the code to be highlighted.
       * @param {Grammar} grammar An object containing the tokens to use.
       *
       * Usually a language definition like `Prism.languages.markup`.
       * @returns {TokenStream} An array of strings and tokens, a token stream.
       * @memberof Prism
       * @public
       * @example
       * let code = `var foo = 0;`;
       * let tokens = Prism.tokenize(code, Prism.languages.javascript);
       * tokens.forEach(token => {
       *     if (token instanceof Prism.Token && token.type === 'number') {
       *         console.log(`Found numeric literal: ${token.content}`);
       *     }
       * });
       */
      tokenize: function(l, r) {
        var g = r.rest;
        if (g) {
          for (var c in g)
            r[c] = g[c];
          delete r.rest;
        }
        var s = new y();
        return b(s, s.head, l), m(l, s, r, s.head, 0), E(s);
      },
      /**
       * @namespace
       * @memberof Prism
       * @public
       */
      hooks: {
        all: {},
        /**
         * Adds the given callback to the list of callbacks for the given hook.
         *
         * The callback will be invoked when the hook it is registered for is run.
         * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
         *
         * One callback function can be registered to multiple hooks and the same hook multiple times.
         *
         * @param {string} name The name of the hook.
         * @param {HookCallback} callback The callback function which is given environment variables.
         * @public
         */
        add: function(l, r) {
          var g = i.hooks.all;
          g[l] = g[l] || [], g[l].push(r);
        },
        /**
         * Runs a hook invoking all registered callbacks with the given environment variables.
         *
         * Callbacks will be invoked synchronously and in the order in which they were registered.
         *
         * @param {string} name The name of the hook.
         * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
         * @public
         */
        run: function(l, r) {
          var g = i.hooks.all[l];
          if (!(!g || !g.length))
            for (var c = 0, s; s = g[c++]; )
              s(r);
        }
      },
      Token: v
    };
    a.Prism = i;
    function v(l, r, g, c) {
      this.type = l, this.content = r, this.alias = g, this.length = (c || "").length | 0;
    }
    v.stringify = function l(r, g) {
      if (typeof r == "string")
        return r;
      if (Array.isArray(r)) {
        var c = "";
        return r.forEach(function($) {
          c += l($, g);
        }), c;
      }
      var s = {
        type: r.type,
        content: l(r.content, g),
        tag: "span",
        classes: ["token", r.type],
        attributes: {},
        language: g
      }, f = r.alias;
      f && (Array.isArray(f) ? Array.prototype.push.apply(s.classes, f) : s.classes.push(f)), i.hooks.run("wrap", s);
      var x = "";
      for (var p in s.attributes)
        x += " " + p + '="' + (s.attributes[p] || "").replace(/"/g, "&quot;") + '"';
      return "<" + s.tag + ' class="' + s.classes.join(" ") + '"' + x + ">" + s.content + "</" + s.tag + ">";
    };
    function k(l, r, g, c) {
      l.lastIndex = r;
      var s = l.exec(g);
      if (s && c && s[1]) {
        var f = s[1].length;
        s.index += f, s[0] = s[0].slice(f);
      }
      return s;
    }
    function m(l, r, g, c, s, f) {
      for (var x in g)
        if (!(!g.hasOwnProperty(x) || !g[x])) {
          var p = g[x];
          p = Array.isArray(p) ? p : [p];
          for (var $ = 0; $ < p.length; ++$) {
            if (f && f.cause == x + "," + $)
              return;
            var L = p[$], I = L.inside, R = !!L.lookbehind, U = !!L.greedy, B = L.alias;
            if (U && !L.pattern.global) {
              var M = L.pattern.toString().match(/[imsuy]*$/)[0];
              L.pattern = RegExp(L.pattern.source, M + "g");
            }
            for (var K = L.pattern || L, F = c.next, O = s; F !== r.tail && !(f && O >= f.reach); O += F.value.length, F = F.next) {
              var j = F.value;
              if (r.length > l.length)
                return;
              if (!(j instanceof v)) {
                var C = 1, _;
                if (U) {
                  if (_ = k(K, O, l, R), !_ || _.index >= l.length)
                    break;
                  var Z = _.index, re = _.index + _[0].length, q = O;
                  for (q += F.value.length; Z >= q; )
                    F = F.next, q += F.value.length;
                  if (q -= F.value.length, O = q, F.value instanceof v)
                    continue;
                  for (var J = F; J !== r.tail && (q < re || typeof J.value == "string"); J = J.next)
                    C++, q += J.value.length;
                  C--, j = l.slice(O, q), _.index -= O;
                } else if (_ = k(K, 0, j, R), !_)
                  continue;
                var Z = _.index, Y = _[0], ce = j.slice(0, Z), Ye = j.slice(Z + Y.length), we = O + j.length;
                f && we > f.reach && (f.reach = we);
                var he = F.prev;
                ce && (he = b(r, he, ce), O += ce.length), h(r, he, C);
                var rt = new v(x, I ? i.tokenize(Y, I) : Y, B, Y);
                if (F = b(r, he, rt), Ye && b(r, F, Ye), C > 1) {
                  var Se = {
                    cause: x + "," + $,
                    reach: we
                  };
                  m(l, r, g, F.prev, O, Se), f && Se.reach > f.reach && (f.reach = Se.reach);
                }
              }
            }
          }
        }
    }
    function y() {
      var l = { value: null, prev: null, next: null }, r = { value: null, prev: l, next: null };
      l.next = r, this.head = l, this.tail = r, this.length = 0;
    }
    function b(l, r, g) {
      var c = r.next, s = { value: g, prev: r, next: c };
      return r.next = s, c.prev = s, l.length++, s;
    }
    function h(l, r, g) {
      for (var c = r.next, s = 0; s < g && c !== l.tail; s++)
        c = c.next;
      r.next = c, c.prev = r, l.length -= s;
    }
    function E(l) {
      for (var r = [], g = l.head.next; g !== l.tail; )
        r.push(g.value), g = g.next;
      return r;
    }
    if (!a.document)
      return a.addEventListener && (i.disableWorkerMessageHandler || a.addEventListener("message", function(l) {
        var r = JSON.parse(l.data), g = r.language, c = r.code, s = r.immediateClose;
        a.postMessage(i.highlight(c, i.languages[g], g)), s && a.close();
      }, !1)), i;
    var w = i.util.currentScript();
    w && (i.filename = w.src, w.hasAttribute("data-manual") && (i.manual = !0));
    function T() {
      i.manual || i.highlightAll();
    }
    if (!i.manual) {
      var A = document.readyState;
      A === "loading" || A === "interactive" && w && w.defer ? document.addEventListener("DOMContentLoaded", T) : window.requestAnimationFrame ? window.requestAnimationFrame(T) : window.setTimeout(T, 16);
    }
    return i;
  }(n);
  e.exports && (e.exports = t), typeof be < "u" && (be.Prism = t);
})(Yn);
var Sl = Yn.exports, kl = We;
We.displayName = "markup";
We.aliases = ["html", "mathml", "svg", "xml", "ssml", "atom", "rss"];
function We(e) {
  e.languages.markup = {
    comment: {
      pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
      greedy: !0
    },
    prolog: {
      pattern: /<\?[\s\S]+?\?>/,
      greedy: !0
    },
    doctype: {
      // https://www.w3.org/TR/xml/#NT-doctypedecl
      pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
      greedy: !0,
      inside: {
        "internal-subset": {
          pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
          lookbehind: !0,
          greedy: !0,
          inside: null
          // see below
        },
        string: {
          pattern: /"[^"]*"|'[^']*'/,
          greedy: !0
        },
        punctuation: /^<!|>$|[[\]]/,
        "doctype-tag": /^DOCTYPE/i,
        name: /[^\s<>'"]+/
      }
    },
    cdata: {
      pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
      greedy: !0
    },
    tag: {
      pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
      greedy: !0,
      inside: {
        tag: {
          pattern: /^<\/?[^\s>\/]+/,
          inside: {
            punctuation: /^<\/?/,
            namespace: /^[^\s>\/:]+:/
          }
        },
        "special-attr": [],
        "attr-value": {
          pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
          inside: {
            punctuation: [
              {
                pattern: /^=/,
                alias: "attr-equals"
              },
              /"|'/
            ]
          }
        },
        punctuation: /\/?>/,
        "attr-name": {
          pattern: /[^\s>\/]+/,
          inside: {
            namespace: /^[^\s>\/:]+:/
          }
        }
      }
    },
    entity: [
      {
        pattern: /&[\da-z]{1,8};/i,
        alias: "named-entity"
      },
      /&#x?[\da-f]{1,8};/i
    ]
  }, e.languages.markup.tag.inside["attr-value"].inside.entity = e.languages.markup.entity, e.languages.markup.doctype.inside["internal-subset"].inside = e.languages.markup, e.hooks.add("wrap", function(n) {
    n.type === "entity" && (n.attributes.title = n.content.value.replace(/&amp;/, "&"));
  }), Object.defineProperty(e.languages.markup.tag, "addInlined", {
    /**
     * Adds an inlined language to markup.
     *
     * An example of an inlined language is CSS with `<style>` tags.
     *
     * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addInlined('style', 'css');
     */
    value: function(t, a) {
      var o = {};
      o["language-" + a] = {
        pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
        lookbehind: !0,
        inside: e.languages[a]
      }, o.cdata = /^<!\[CDATA\[|\]\]>$/i;
      var u = {
        "included-cdata": {
          pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
          inside: o
        }
      };
      u["language-" + a] = {
        pattern: /[\s\S]+/,
        inside: e.languages[a]
      };
      var d = {};
      d[t] = {
        pattern: RegExp(
          /(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(
            /__/g,
            function() {
              return t;
            }
          ),
          "i"
        ),
        lookbehind: !0,
        greedy: !0,
        inside: u
      }, e.languages.insertBefore("markup", "cdata", d);
    }
  }), Object.defineProperty(e.languages.markup.tag, "addAttribute", {
    /**
     * Adds an pattern to highlight languages embedded in HTML attributes.
     *
     * An example of an inlined language is CSS with `style` attributes.
     *
     * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addAttribute('style', 'css');
     */
    value: function(n, t) {
      e.languages.markup.tag.inside["special-attr"].push({
        pattern: RegExp(
          /(^|["'\s])/.source + "(?:" + n + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
          "i"
        ),
        lookbehind: !0,
        inside: {
          "attr-name": /^[^\s=]+/,
          "attr-value": {
            pattern: /=[\s\S]+/,
            inside: {
              value: {
                pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                lookbehind: !0,
                alias: [t, "language-" + t],
                inside: e.languages[t]
              },
              punctuation: [
                {
                  pattern: /^=/,
                  alias: "attr-equals"
                },
                /"|'/
              ]
            }
          }
        }
      });
    }
  }), e.languages.html = e.languages.markup, e.languages.mathml = e.languages.markup, e.languages.svg = e.languages.markup, e.languages.xml = e.languages.extend("markup", {}), e.languages.ssml = e.languages.xml, e.languages.atom = e.languages.xml, e.languages.rss = e.languages.xml;
}
var Xn = Ze;
Ze.displayName = "css";
Ze.aliases = [];
function Ze(e) {
  (function(n) {
    var t = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    n.languages.css = {
      comment: /\/\*[\s\S]*?\*\//,
      atrule: {
        pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
        inside: {
          rule: /^@[\w-]+/,
          "selector-function-argument": {
            pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
            lookbehind: !0,
            alias: "selector"
          },
          keyword: {
            pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
            lookbehind: !0
          }
          // See rest below
        }
      },
      url: {
        // https://drafts.csswg.org/css-values-3/#urls
        pattern: RegExp(
          "\\burl\\((?:" + t.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)",
          "i"
        ),
        greedy: !0,
        inside: {
          function: /^url/i,
          punctuation: /^\(|\)$/,
          string: {
            pattern: RegExp("^" + t.source + "$"),
            alias: "url"
          }
        }
      },
      selector: {
        pattern: RegExp(
          `(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + t.source + ")*(?=\\s*\\{)"
        ),
        lookbehind: !0
      },
      string: {
        pattern: t,
        greedy: !0
      },
      property: {
        pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
        lookbehind: !0
      },
      important: /!important\b/i,
      function: {
        pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
        lookbehind: !0
      },
      punctuation: /[(){};:,]/
    }, n.languages.css.atrule.inside.rest = n.languages.css;
    var a = n.languages.markup;
    a && (a.tag.addInlined("style", "css"), a.tag.addAttribute("style", "css"));
  })(e);
}
const $l = /* @__PURE__ */ ee(Xn);
var Al = Ge;
Ge.displayName = "clike";
Ge.aliases = [];
function Ge(e) {
  e.languages.clike = {
    comment: [
      {
        pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
        lookbehind: !0,
        greedy: !0
      },
      {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: !0,
        greedy: !0
      }
    ],
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    "class-name": {
      pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
      lookbehind: !0,
      inside: {
        punctuation: /[.\\]/
      }
    },
    keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b\w+(?=\()/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    punctuation: /[{}[\];(),.:]/
  };
}
var Fl = Ve;
Ve.displayName = "javascript";
Ve.aliases = ["js"];
function Ve(e) {
  e.languages.javascript = e.languages.extend("clike", {
    "class-name": [
      e.languages.clike["class-name"],
      {
        pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
        lookbehind: !0
      }
    ],
    keyword: [
      {
        pattern: /((?:^|\})\s*)catch\b/,
        lookbehind: !0
      },
      {
        pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
        lookbehind: !0
      }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    number: {
      pattern: RegExp(
        /(^|[^\w$])/.source + "(?:" + // constant
        (/NaN|Infinity/.source + "|" + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
        /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source
      ),
      lookbehind: !0
    },
    operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
  }), e.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, e.languages.insertBefore("javascript", "keyword", {
    regex: {
      // eslint-disable-next-line regexp/no-dupe-characters-character-class
      pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        "regex-source": {
          pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
          lookbehind: !0,
          alias: "language-regex",
          inside: e.languages.regex
        },
        "regex-delimiter": /^\/|\/$/,
        "regex-flags": /^[a-z]+$/
      }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    "function-variable": {
      pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
      alias: "function"
    },
    parameter: [
      {
        pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
        lookbehind: !0,
        inside: e.languages.javascript
      },
      {
        pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
        lookbehind: !0,
        inside: e.languages.javascript
      },
      {
        pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
        lookbehind: !0,
        inside: e.languages.javascript
      },
      {
        pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
        lookbehind: !0,
        inside: e.languages.javascript
      }
    ],
    constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
  }), e.languages.insertBefore("javascript", "string", {
    hashbang: {
      pattern: /^#!.*/,
      greedy: !0,
      alias: "comment"
    },
    "template-string": {
      pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
      greedy: !0,
      inside: {
        "template-punctuation": {
          pattern: /^`|`$/,
          alias: "string"
        },
        interpolation: {
          pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
          lookbehind: !0,
          inside: {
            "interpolation-punctuation": {
              pattern: /^\$\{|\}$/,
              alias: "punctuation"
            },
            rest: e.languages.javascript
          }
        },
        string: /[\s\S]+/
      }
    },
    "string-property": {
      pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
      lookbehind: !0,
      greedy: !0,
      alias: "property"
    }
  }), e.languages.insertBefore("javascript", "operator", {
    "literal-property": {
      pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
      lookbehind: !0,
      alias: "property"
    }
  }), e.languages.markup && (e.languages.markup.tag.addInlined("script", "javascript"), e.languages.markup.tag.addAttribute(
    /on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
    "javascript"
  )), e.languages.js = e.languages.javascript;
}
var de = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof be == "object" ? be : {}, Cl = Ul();
de.Prism = { manual: !0, disableWorkerMessageHandler: !0 };
var Ll = Ha, El = ol, Pn = Sl, Nl = kl, Tl = Xn, jl = Al, Ol = Fl;
Cl();
var Ke = {}.hasOwnProperty;
function Qn() {
}
Qn.prototype = Pn;
var z = new Qn(), Il = z;
z.highlight = zl;
z.register = fe;
z.alias = _l;
z.registered = Rl;
z.listLanguages = Ml;
fe(Nl);
fe(Tl);
fe(jl);
fe(Ol);
z.util.encode = ql;
z.Token.stringify = Dl;
function fe(e) {
  if (typeof e != "function" || !e.displayName)
    throw new Error("Expected `function` for `grammar`, got `" + e + "`");
  z.languages[e.displayName] === void 0 && e(z);
}
function _l(e, n) {
  var t = z.languages, a = e, o, u, d, i;
  n && (a = {}, a[e] = n);
  for (o in a)
    for (u = a[o], u = typeof u == "string" ? [u] : u, d = u.length, i = -1; ++i < d; )
      t[u[i]] = t[o];
}
function zl(e, n) {
  var t = Pn.highlight, a;
  if (typeof e != "string")
    throw new Error("Expected `string` for `value`, got `" + e + "`");
  if (z.util.type(n) === "Object")
    a = n, n = null;
  else {
    if (typeof n != "string")
      throw new Error("Expected `string` for `name`, got `" + n + "`");
    if (Ke.call(z.languages, n))
      a = z.languages[n];
    else
      throw new Error("Unknown language: `" + n + "` is not registered");
  }
  return t.call(this, e, a, n);
}
function Rl(e) {
  if (typeof e != "string")
    throw new Error("Expected `string` for `language`, got `" + e + "`");
  return Ke.call(z.languages, e);
}
function Ml() {
  var e = z.languages, n = [], t;
  for (t in e)
    Ke.call(e, t) && typeof e[t] == "object" && n.push(t);
  return n;
}
function Dl(e, n, t) {
  var a;
  return typeof e == "string" ? { type: "text", value: e } : z.util.type(e) === "Array" ? Bl(e, n) : (a = {
    type: e.type,
    content: z.Token.stringify(e.content, n, t),
    tag: "span",
    classes: ["token", e.type],
    attributes: {},
    language: n,
    parent: t
  }, e.alias && (a.classes = a.classes.concat(e.alias)), z.hooks.run("wrap", a), Ll(
    a.tag + "." + a.classes.join("."),
    Hl(a.attributes),
    a.content
  ));
}
function Bl(e, n) {
  for (var t = [], a = e.length, o = -1, u; ++o < a; )
    u = e[o], u !== "" && u !== null && u !== void 0 && t.push(u);
  for (o = -1, a = t.length; ++o < a; )
    u = t[o], t[o] = z.Token.stringify(u, n, t);
  return t;
}
function ql(e) {
  return e;
}
function Hl(e) {
  var n;
  for (n in e)
    e[n] = El(e[n]);
  return e;
}
function Ul() {
  var e = "Prism" in de, n = e ? de.Prism : void 0;
  return t;
  function t() {
    e ? de.Prism = n : delete de.Prism, e = void 0, n = void 0;
  }
}
const Je = /* @__PURE__ */ ee(Il);
var W = $t(Je, {});
W.registerLanguage = function(e, n) {
  return Je.register(n);
};
W.alias = function(e, n) {
  return Je.alias(e, n);
};
var Ae, yn;
function Wl() {
  if (yn) return Ae;
  yn = 1, Ae = e, e.displayName = "typescript", e.aliases = ["ts"];
  function e(n) {
    (function(t) {
      t.languages.typescript = t.languages.extend("javascript", {
        "class-name": {
          pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
          lookbehind: !0,
          greedy: !0,
          inside: null
          // see below
        },
        builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
      }), t.languages.typescript.keyword.push(
        /\b(?:abstract|declare|is|keyof|readonly|require)\b/,
        // keywords that have to be followed by an identifier
        /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/,
        // This is for `import type *, {}`
        /\btype\b(?=\s*(?:[\{*]|$))/
      ), delete t.languages.typescript.parameter, delete t.languages.typescript["literal-property"];
      var a = t.languages.extend("typescript", {});
      delete a["class-name"], t.languages.typescript["class-name"].inside = a, t.languages.insertBefore("typescript", "function", {
        decorator: {
          pattern: /@[$\w\xA0-\uFFFF]+/,
          inside: {
            at: {
              pattern: /^@/,
              alias: "operator"
            },
            function: /^[\s\S]+/
          }
        },
        "generic-function": {
          // e.g. foo<T extends "bar" | "baz">( ...
          pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
          greedy: !0,
          inside: {
            function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
            generic: {
              pattern: /<[\s\S]+/,
              // everything after the first <
              alias: "class-name",
              inside: a
            }
          }
        }
      }), t.languages.ts = t.languages.typescript;
    })(n);
  }
  return Ae;
}
var Fe, bn;
function Zl() {
  if (bn) return Fe;
  bn = 1, Fe = e, e.displayName = "json", e.aliases = ["webmanifest"];
  function e(n) {
    n.languages.json = {
      property: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
        lookbehind: !0,
        greedy: !0
      },
      comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: !0
      },
      number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
      punctuation: /[{}[\],]/,
      operator: /:/,
      boolean: /\b(?:false|true)\b/,
      null: {
        pattern: /\bnull\b/,
        alias: "keyword"
      }
    }, n.languages.webmanifest = n.languages.json;
  }
  return Fe;
}
var Ce, xn;
function et() {
  if (xn) return Ce;
  xn = 1, Ce = e, e.displayName = "jsx", e.aliases = [];
  function e(n) {
    (function(t) {
      var a = t.util.clone(t.languages.javascript), o = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, u = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source, d = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
      function i(m, y) {
        return m = m.replace(/<S>/g, function() {
          return o;
        }).replace(/<BRACES>/g, function() {
          return u;
        }).replace(/<SPREAD>/g, function() {
          return d;
        }), RegExp(m, y);
      }
      d = i(d).source, t.languages.jsx = t.languages.extend("markup", a), t.languages.jsx.tag.pattern = i(
        /<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source
      ), t.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, t.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/, t.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, t.languages.jsx.tag.inside.comment = a.comment, t.languages.insertBefore(
        "inside",
        "attr-name",
        {
          spread: {
            pattern: i(/<SPREAD>/.source),
            inside: t.languages.jsx
          }
        },
        t.languages.jsx.tag
      ), t.languages.insertBefore(
        "inside",
        "special-attr",
        {
          script: {
            // Allow for two levels of nesting
            pattern: i(/=<BRACES>/.source),
            alias: "language-javascript",
            inside: {
              "script-punctuation": {
                pattern: /^=(?=\{)/,
                alias: "punctuation"
              },
              rest: t.languages.jsx
            }
          }
        },
        t.languages.jsx.tag
      );
      var v = function(m) {
        return m ? typeof m == "string" ? m : typeof m.content == "string" ? m.content : m.content.map(v).join("") : "";
      }, k = function(m) {
        for (var y = [], b = 0; b < m.length; b++) {
          var h = m[b], E = !1;
          if (typeof h != "string" && (h.type === "tag" && h.content[0] && h.content[0].type === "tag" ? h.content[0].content[0].content === "</" ? y.length > 0 && y[y.length - 1].tagName === v(h.content[0].content[1]) && y.pop() : h.content[h.content.length - 1].content === "/>" || y.push({
            tagName: v(h.content[0].content[1]),
            openedBraces: 0
          }) : y.length > 0 && h.type === "punctuation" && h.content === "{" ? y[y.length - 1].openedBraces++ : y.length > 0 && y[y.length - 1].openedBraces > 0 && h.type === "punctuation" && h.content === "}" ? y[y.length - 1].openedBraces-- : E = !0), (E || typeof h == "string") && y.length > 0 && y[y.length - 1].openedBraces === 0) {
            var w = v(h);
            b < m.length - 1 && (typeof m[b + 1] == "string" || m[b + 1].type === "plain-text") && (w += v(m[b + 1]), m.splice(b + 1, 1)), b > 0 && (typeof m[b - 1] == "string" || m[b - 1].type === "plain-text") && (w = v(m[b - 1]) + w, m.splice(b - 1, 1), b--), m[b] = new t.Token(
              "plain-text",
              w,
              null,
              w
            );
          }
          h.content && typeof h.content != "string" && k(h.content);
        }
      };
      t.hooks.add("after-tokenize", function(m) {
        m.language !== "jsx" && m.language !== "tsx" || k(m.tokens);
      });
    })(n);
  }
  return Ce;
}
var Le, wn;
function Gl() {
  if (wn) return Le;
  wn = 1, Le = e, e.displayName = "markdown", e.aliases = ["md"];
  function e(n) {
    (function(t) {
      var a = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
      function o(b) {
        return b = b.replace(/<inner>/g, function() {
          return a;
        }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + b + ")");
      }
      var u = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, d = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(
        /__/g,
        function() {
          return u;
        }
      ), i = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
      t.languages.markdown = t.languages.extend("markup", {}), t.languages.insertBefore("markdown", "prolog", {
        "front-matter-block": {
          pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
          lookbehind: !0,
          greedy: !0,
          inside: {
            punctuation: /^---|---$/,
            "front-matter": {
              pattern: /\S+(?:\s+\S+)*/,
              alias: ["yaml", "language-yaml"],
              inside: t.languages.yaml
            }
          }
        },
        blockquote: {
          // > ...
          pattern: /^>(?:[\t ]*>)*/m,
          alias: "punctuation"
        },
        table: {
          pattern: RegExp(
            "^" + d + i + "(?:" + d + ")*",
            "m"
          ),
          inside: {
            "table-data-rows": {
              pattern: RegExp(
                "^(" + d + i + ")(?:" + d + ")*$"
              ),
              lookbehind: !0,
              inside: {
                "table-data": {
                  pattern: RegExp(u),
                  inside: t.languages.markdown
                },
                punctuation: /\|/
              }
            },
            "table-line": {
              pattern: RegExp("^(" + d + ")" + i + "$"),
              lookbehind: !0,
              inside: {
                punctuation: /\||:?-{3,}:?/
              }
            },
            "table-header-row": {
              pattern: RegExp("^" + d + "$"),
              inside: {
                "table-header": {
                  pattern: RegExp(u),
                  alias: "important",
                  inside: t.languages.markdown
                },
                punctuation: /\|/
              }
            }
          }
        },
        code: [
          {
            // Prefixed by 4 spaces or 1 tab and preceded by an empty line
            pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
            lookbehind: !0,
            alias: "keyword"
          },
          {
            // ```optional language
            // code block
            // ```
            pattern: /^```[\s\S]*?^```$/m,
            greedy: !0,
            inside: {
              "code-block": {
                pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
                lookbehind: !0
              },
              "code-language": {
                pattern: /^(```).+/,
                lookbehind: !0
              },
              punctuation: /```/
            }
          }
        ],
        title: [
          {
            // title 1
            // =======
            // title 2
            // -------
            pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
            alias: "important",
            inside: {
              punctuation: /==+$|--+$/
            }
          },
          {
            // # title 1
            // ###### title 6
            pattern: /(^\s*)#.+/m,
            lookbehind: !0,
            alias: "important",
            inside: {
              punctuation: /^#+|#+$/
            }
          }
        ],
        hr: {
          // ***
          // ---
          // * * *
          // -----------
          pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
          lookbehind: !0,
          alias: "punctuation"
        },
        list: {
          // * item
          // + item
          // - item
          // 1. item
          pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
          lookbehind: !0,
          alias: "punctuation"
        },
        "url-reference": {
          // [id]: http://example.com "Optional title"
          // [id]: http://example.com 'Optional title'
          // [id]: http://example.com (Optional title)
          // [id]: <http://example.com> "Optional title"
          pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
          inside: {
            variable: {
              pattern: /^(!?\[)[^\]]+/,
              lookbehind: !0
            },
            string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
            punctuation: /^[\[\]!:]|[<>]/
          },
          alias: "url"
        },
        bold: {
          // **strong**
          // __strong__
          // allow one nested instance of italic text using the same delimiter
          pattern: o(
            /\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            content: {
              pattern: /(^..)[\s\S]+(?=..$)/,
              lookbehind: !0,
              inside: {}
              // see below
            },
            punctuation: /\*\*|__/
          }
        },
        italic: {
          // *em*
          // _em_
          // allow one nested instance of bold text using the same delimiter
          pattern: o(
            /\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            content: {
              pattern: /(^.)[\s\S]+(?=.$)/,
              lookbehind: !0,
              inside: {}
              // see below
            },
            punctuation: /[*_]/
          }
        },
        strike: {
          // ~~strike through~~
          // ~strike~
          // eslint-disable-next-line regexp/strict
          pattern: o(/(~~?)(?:(?!~)<inner>)+\2/.source),
          lookbehind: !0,
          greedy: !0,
          inside: {
            content: {
              pattern: /(^~~?)[\s\S]+(?=\1$)/,
              lookbehind: !0,
              inside: {}
              // see below
            },
            punctuation: /~~?/
          }
        },
        "code-snippet": {
          // `code`
          // ``code``
          pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
          lookbehind: !0,
          greedy: !0,
          alias: ["code", "keyword"]
        },
        url: {
          // [example](http://example.com "Optional title")
          // [example][id]
          // [example] [id]
          pattern: o(
            /!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            operator: /^!/,
            content: {
              pattern: /(^\[)[^\]]+(?=\])/,
              lookbehind: !0,
              inside: {}
              // see below
            },
            variable: {
              pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
              lookbehind: !0
            },
            url: {
              pattern: /(^\]\()[^\s)]+/,
              lookbehind: !0
            },
            string: {
              pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
              lookbehind: !0
            }
          }
        }
      }), ["url", "bold", "italic", "strike"].forEach(function(b) {
        ["url", "bold", "italic", "strike", "code-snippet"].forEach(function(h) {
          b !== h && (t.languages.markdown[b].inside.content.inside[h] = t.languages.markdown[h]);
        });
      }), t.hooks.add("after-tokenize", function(b) {
        if (b.language !== "markdown" && b.language !== "md")
          return;
        function h(E) {
          if (!(!E || typeof E == "string"))
            for (var w = 0, T = E.length; w < T; w++) {
              var A = E[w];
              if (A.type !== "code") {
                h(A.content);
                continue;
              }
              var l = A.content[1], r = A.content[3];
              if (l && r && l.type === "code-language" && r.type === "code-block" && typeof l.content == "string") {
                var g = l.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp");
                g = (/[a-z][\w-]*/i.exec(g) || [""])[0].toLowerCase();
                var c = "language-" + g;
                r.alias ? typeof r.alias == "string" ? r.alias = [r.alias, c] : r.alias.push(c) : r.alias = [c];
              }
            }
        }
        h(b.tokens);
      }), t.hooks.add("wrap", function(b) {
        if (b.type === "code-block") {
          for (var h = "", E = 0, w = b.classes.length; E < w; E++) {
            var T = b.classes[E], A = /language-(.+)/.exec(T);
            if (A) {
              h = A[1];
              break;
            }
          }
          var l = t.languages[h];
          if (l)
            b.content = t.highlight(
              y(b.content.value),
              l,
              h
            );
          else if (h && h !== "none" && t.plugins.autoloader) {
            var r = "md-" + (/* @__PURE__ */ new Date()).valueOf() + "-" + Math.floor(Math.random() * 1e16);
            b.attributes.id = r, t.plugins.autoloader.loadLanguages(h, function() {
              var g = document.getElementById(r);
              g && (g.innerHTML = t.highlight(
                g.textContent,
                t.languages[h],
                h
              ));
            });
          }
        }
      });
      var v = RegExp(t.languages.markup.tag.pattern.source, "gi"), k = {
        amp: "&",
        lt: "<",
        gt: ">",
        quot: '"'
      }, m = String.fromCodePoint || String.fromCharCode;
      function y(b) {
        var h = b.replace(v, "");
        return h = h.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(E, w) {
          if (w = w.toLowerCase(), w[0] === "#") {
            var T;
            return w[1] === "x" ? T = parseInt(w.slice(2), 16) : T = Number(w.slice(1)), m(T);
          } else {
            var A = k[w];
            return A || E;
          }
        }), h;
      }
      t.languages.md = t.languages.markdown;
    })(n);
  }
  return Le;
}
var Ee, Sn;
function Vl() {
  if (Sn) return Ee;
  Sn = 1, Ee = e, e.displayName = "sass", e.aliases = [];
  function e(n) {
    (function(t) {
      t.languages.sass = t.languages.extend("css", {
        // Sass comments don't need to be closed, only indented
        comment: {
          pattern: /^([ \t]*)\/[\/*].*(?:(?:\r?\n|\r)\1[ \t].+)*/m,
          lookbehind: !0,
          greedy: !0
        }
      }), t.languages.insertBefore("sass", "atrule", {
        // We want to consume the whole line
        "atrule-line": {
          // Includes support for = and + shortcuts
          pattern: /^(?:[ \t]*)[@+=].+/m,
          greedy: !0,
          inside: {
            atrule: /(?:@[\w-]+|[+=])/
          }
        }
      }), delete t.languages.sass.atrule;
      var a = /\$[-\w]+|#\{\$[-\w]+\}/, o = [
        /[+*\/%]|[=!]=|<=?|>=?|\b(?:and|not|or)\b/,
        {
          pattern: /(\s)-(?=\s)/,
          lookbehind: !0
        }
      ];
      t.languages.insertBefore("sass", "property", {
        // We want to consume the whole line
        "variable-line": {
          pattern: /^[ \t]*\$.+/m,
          greedy: !0,
          inside: {
            punctuation: /:/,
            variable: a,
            operator: o
          }
        },
        // We want to consume the whole line
        "property-line": {
          pattern: /^[ \t]*(?:[^:\s]+ *:.*|:[^:\s].*)/m,
          greedy: !0,
          inside: {
            property: [
              /[^:\s]+(?=\s*:)/,
              {
                pattern: /(:)[^:\s]+/,
                lookbehind: !0
              }
            ],
            punctuation: /:/,
            variable: a,
            operator: o,
            important: t.languages.sass.important
          }
        }
      }), delete t.languages.sass.property, delete t.languages.sass.important, t.languages.insertBefore("sass", "punctuation", {
        selector: {
          pattern: /^([ \t]*)\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*(?:,(?:\r?\n|\r)\1[ \t]+\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*)*/m,
          lookbehind: !0,
          greedy: !0
        }
      });
    })(n);
  }
  return Ee;
}
var Ne, kn;
function Kl() {
  if (kn) return Ne;
  kn = 1, Ne = e, e.displayName = "scss", e.aliases = [];
  function e(n) {
    n.languages.scss = n.languages.extend("css", {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
        lookbehind: !0
      },
      atrule: {
        pattern: /@[\w-](?:\([^()]+\)|[^()\s]|\s+(?!\s))*?(?=\s+[{;])/,
        inside: {
          rule: /@[\w-]+/
          // See rest below
        }
      },
      // url, compassified
      url: /(?:[-a-z]+-)?url(?=\()/i,
      // CSS selector regex is not appropriate for Sass
      // since there can be lot more things (var, @ directive, nesting..)
      // a selector must start at the end of a property or after a brace (end of other rules or nesting)
      // it can contain some characters that aren't used for defining rules or end of selector, & (parent selector), or interpolated variable
      // the end of a selector is found when there is no rules in it ( {} or {\s}) or if there is a property (because an interpolated var
      // can "pass" as a selector- e.g: proper#{$erty})
      // this one was hard to do, so please be careful if you edit this one :)
      selector: {
        // Initial look-ahead is used to prevent matching of blank selectors
        pattern: /(?=\S)[^@;{}()]?(?:[^@;{}()\s]|\s+(?!\s)|#\{\$[-\w]+\})+(?=\s*\{(?:\}|\s|[^}][^:{}]*[:{][^}]))/,
        inside: {
          parent: {
            pattern: /&/,
            alias: "important"
          },
          placeholder: /%[-\w]+/,
          variable: /\$[-\w]+|#\{\$[-\w]+\}/
        }
      },
      property: {
        pattern: /(?:[-\w]|\$[-\w]|#\{\$[-\w]+\})+(?=\s*:)/,
        inside: {
          variable: /\$[-\w]+|#\{\$[-\w]+\}/
        }
      }
    }), n.languages.insertBefore("scss", "atrule", {
      keyword: [
        /@(?:content|debug|each|else(?: if)?|extend|for|forward|function|if|import|include|mixin|return|use|warn|while)\b/i,
        {
          pattern: /( )(?:from|through)(?= )/,
          lookbehind: !0
        }
      ]
    }), n.languages.insertBefore("scss", "important", {
      // var and interpolated vars
      variable: /\$[-\w]+|#\{\$[-\w]+\}/
    }), n.languages.insertBefore("scss", "function", {
      "module-modifier": {
        pattern: /\b(?:as|hide|show|with)\b/i,
        alias: "keyword"
      },
      placeholder: {
        pattern: /%[-\w]+/,
        alias: "selector"
      },
      statement: {
        pattern: /\B!(?:default|optional)\b/i,
        alias: "keyword"
      },
      boolean: /\b(?:false|true)\b/,
      null: {
        pattern: /\bnull\b/,
        alias: "keyword"
      },
      operator: {
        pattern: /(\s)(?:[-+*\/%]|[=!]=|<=?|>=?|and|not|or)(?=\s)/,
        lookbehind: !0
      }
    }), n.languages.scss.atrule.inside.rest = n.languages.scss;
  }
  return Ne;
}
var Te, $n;
function Jl() {
  if ($n) return Te;
  $n = 1;
  var e = et(), n = Wl();
  Te = t, t.displayName = "tsx", t.aliases = [];
  function t(a) {
    a.register(e), a.register(n), function(o) {
      var u = o.util.clone(o.languages.typescript);
      o.languages.tsx = o.languages.extend("jsx", u), delete o.languages.tsx.parameter, delete o.languages.tsx["literal-property"];
      var d = o.languages.tsx.tag;
      d.pattern = RegExp(
        /(^|[^\w$]|(?=<\/))/.source + "(?:" + d.pattern.source + ")",
        d.pattern.flags
      ), d.lookbehind = !0;
    }(a);
  }
  return Te;
}
var Yl = Zl();
const Xl = /* @__PURE__ */ ee(Yl);
var Pl = et();
const nt = /* @__PURE__ */ ee(Pl);
var Ql = Gl();
const ei = /* @__PURE__ */ ee(Ql);
var ni = Vl();
const tt = /* @__PURE__ */ ee(ni);
var ti = Kl();
const ai = /* @__PURE__ */ ee(ti);
var ri = Jl();
const at = /* @__PURE__ */ ee(ri);
W.registerLanguage("css", $l);
W.registerLanguage("md", ei);
W.registerLanguage("json", Xl);
W.registerLanguage("js", nt);
W.registerLanguage("jsx", nt);
W.registerLanguage("less", tt);
W.registerLanguage("sass", tt);
W.registerLanguage("scss", ai);
W.registerLanguage("ts", at);
W.registerLanguage("tsx", at);
const oi = ['code[class*="language-"]'];
function li(e) {
  const n = {};
  for (const t in e)
    oi.includes(t) || (n[t] = {
      ...e[t],
      background: void 0
    });
  return n;
}
const di = ({ children: e, language: n, ...t }) => n ? /* @__PURE__ */ ke(
  W,
  {
    customStyle: {
      background: "none",
      backgroundColor: "none",
      margin: "0",
      marginBottom: "0",
      padding: "0"
    },
    CodeTag: Xe,
    PreTag: ({ children: a }) => /* @__PURE__ */ ke(ot, { children: a }),
    language: n,
    style: li(ct),
    ...t,
    children: e
  }
) : /* @__PURE__ */ ke(Xe, { ...t, children: e });
export {
  di as default
};
